import { createContext, useContext } from 'react';

import type { EmbedParams } from './embed-params';

export interface EmbedContextValue {
  /** True when MDenture is rendered inside an iframe. */
  embedded: boolean;
  /** Allowlisted parameters handed over by the host page. */
  params: EmbedParams;
  /**
   * Sends a message to the embedding host page. No-op when not embedded or when
   * no trusted parent origin is configured — never posts to '*'.
   */
  postToHost: (message: { type: string; [key: string]: unknown }) => void;
}

export const EmbedContext = createContext<EmbedContextValue | null>(null);

export function useEmbed(): EmbedContextValue {
  const context = useContext(EmbedContext);
  if (!context) {
    throw new Error('useEmbed must be used inside <EmbedProvider>.');
  }
  return context;
}
